import * as z from "zod";

export const startMiraklSync = {
  name: "startMiraklSync" as const,
  input: z.object({}),
  output: z.discriminatedUnion("started", [
    z.object({ started: z.literal(true), workflowId: z.string() }),
    z.object({
      started: z.literal(false),
      reason: z.enum(["not_connected", "already_running"]),
    }),
  ]),
};
